/**
 * "Open" for a notification: the dashboard uses section state, not routes, so navigation goes
 * through the dashboard's window events (ids and labels only, never PHI).
 */
import type { NotificationTarget } from '../../dtos/notifications/notification.mapper';
import { OPEN_ADMIN_TAB_EVENT, openDashboardSection, openPatientChartById } from '../../constants/navigationEvents';

export function navigateToNotificationTarget(target: NotificationTarget | null): boolean {
  if (!target) return false;
  switch (target.kind) {
    case 'patient':
      openPatientChartById(target.patientId, target.tab);
      return true;
    case 'schedule':
      openDashboardSection('Schedule', target.view);
      return true;
    case 'billing':
      openDashboardSection('Billing', target.tab);
      return true;
    case 'admin':
      window.dispatchEvent(new CustomEvent(OPEN_ADMIN_TAB_EVENT, { detail: target.tab }));
      return true;
    default:
      return false;
  }
}
